import { deleteApi, get, post } from "../GenericServices";

const OrderAllocation = {
  listOdaAllocationSuppliers: (queryString) => {
    return get(`order-allocation/suppliers?${queryString}`);
  },
  listOdaCostCentersByUser: () => {
    return get(`order-allocation/cost-centres`);
  },
  listOdaBySupplierId: (queryString) => {
    return get(`order-allocation/orders?${queryString}`);
  },
  listOdaProjectsByOderId: (orderId) => {
    return get(`order-allocation/project-tasks-order?${orderId}`);
  },
  updateOdaProjectTaskEnabled: (data) => {
    return post(`order-allocation/update-enabled`, data);
  },
  listOdaProjects: (queryString) => {
    return get(`order-allocation/projects?${queryString}`);
  },
  listOdaProjectsTask: (queryString) => {
    return get(`order-allocation/project-tasks?${queryString}`);
  },
  saveNewOda: (data) => {
    return post(`order-allocation`, data);
  },
  deleteOdaProjectTask: (id) => {
    return deleteApi(`order-allocation/${id}`);
  },
  updateHourlyRate: (data) => {
    return post(`order-allocation/update-hourly-rate`, data);
  },
};

export default OrderAllocation;
